import {setMessage, isVisible} from './message'
import {setLoadingStatus, editingInProgress} from './loaderAction';
import {clientFetchData} from './clientData'
import firebase from '../components/Firebase'
import _ from 'lodash';

export const setAllFiles = (data) => {
    return {
        type: 'SET_ALL_FILES',
        files: data
    }
}

export const removeLastFileId = () => {
    return {
        type : 'REMOVE_LAST_FILE_ID'
    }
}

export const fileEdited = (status) => {
    return {
        type: 'FILE_HAS_BEEN_EDITED',
        status
    }
}

export const setFileInProgress = (payload) => {
    return {
        type: 'FILE_IN_PROGRESS',
        payload : payload

    }
}



export const navigateToFileWithId = (fileId, data) => {
    data = data.files;
    for(let i = 0; i <= data.length; i++) {
        if(data[i]) {
            if(data[i]['id'] === fileId) {

            }
        }
    }
}

export const getAllFiles = (url, goToFileId = false, fileId = false) => {

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'FileReducer', status: true}))
        const fileDataRef = firebase.database().ref('fileData');

        fileDataRef.on('value', (snapshot) => {
            let data = null;

            if(data = snapshot.val()) {
                const negative = -1;
                delete data.files[negative];

                data["files"] = _.toArray(data.files);

                dispatch(setAllFiles(data))
                dispatch(setLoadingStatus({reducer: 'FileReducer', status: false}))

            } else {

                fetch(url + '/api/files/action/getAllFiles')
                .then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }

                    return response;
                })
                .then((response) => response.json())
                .then((data) => {

                    dispatch(setAllFiles(data))
                    fileDataRef.set(data);
                    dispatch(setLoadingStatus({reducer: 'FileReducer', status: false}))

                    if(goToFileId === true) {

                        dispatch(navigateToFileWithId(fileId, data));
                    }

                })
                .catch((error) => {


                });
            }
        })
    };
}



export const uploadFile = (url, fileData, postData, fileId = false) => {

    let attachedValues = {};
    const currentAttachedValues = postData.attached_values;
    for(const key in currentAttachedValues ) {
        if ( currentAttachedValues.hasOwnProperty(key)) {
            if(currentAttachedValues[key] !== '' && currentAttachedValues[key] !== null && currentAttachedValues[key] !== false) {
                attachedValues = {
                    ...attachedValues,
                    [key] : currentAttachedValues[key]
                }
            }
        }
    }

    let data = new FormData;
    data.append('filename', fileData[0]);
    data.append('file_type_id', postData.file_type_id);
    data.append('uploaded_by', postData.uploaded_by);
    data.append('product_id', postData.product_id);
    data.append('attached_values', JSON.stringify(attachedValues));
    data.append('address_id', postData.selectedAddress.value);
    data.append('send_message', postData.send_message);
    data.append('is_priority', postData.is_priority);
    data.append('is_been_notified', postData.is_been_notified);
    data.append('check_for_errors', true);

    if(fileId) {
        data.append('id', fileId);
    }

    let formData = data;

    return (dispatch) => {
        const unique = '_' + Math.random().toString(36).substr(2, 9);
        dispatch(setFileInProgress({unique: unique, progress: true, filename: fileData[0], message: 'Upload in progress'}))
        fetch(url + '/api/files/action/uploadFile',
        {
            method: "POST",
            body: data
        })
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return response;
        })
        .then((response) => response.json())
        .then((data) => {
            data = JSON.parse(data);

            // -- Checks have been executed; GO for uploading the file.
            if ( data.message === 'start_upload') {
                dispatch(fileEdited(true));

                formData.delete('check_for_errors');
                fetch(url + '/api/files/action/uploadFile',
                {
                    method: "POST",
                    body: formData
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw Error(response.statusText);
                        }

                        return response;
                    })
                    .then((response) => response.json())
                    .then((data) => {
                        data = JSON.parse(data);
                        if(data.type == 'success') {

                            // -- update firebase
                            // -- when file is updated
                            if(postData.fileEdit == true) {
                                firebase.database().ref('clientData/data/allAddresses/').child(postData.addressIndex).child('files').child(postData.addressFileIndex).set(data.dbRecord);
                                firebase.database().ref('fileData/files').child(postData.fileIndex).set(data.dbRecord);
                            } else { // -- when a new file is uploaded
                                firebase.database().ref('clientData/data/allAddresses/').child(postData.addressIndex).child('files').child(postData.newAddressFileKey).set(data.dbRecord);
                                firebase.database().ref('fileData/files').child(postData.newFileKey).set(data.dbRecord);
                            }
                        }
                        dispatch(setFileInProgress({unique: unique, progress: false, filename: fileData[0], message: data.message}))
                    })
                    .catch((error) => {
                        dispatch(setFileInProgress({unique: unique, progress: false, filename: fileData[0], message: 'Er heeft zich een fout voorgedaan'}))
                    });
            } else {
                dispatch(setFileInProgress({unique: unique, progress: false, filename: fileData[0], message: data.message}))
            }
        })
        .catch((error) => {
            dispatch(setFileInProgress({unique: unique, progress: false, filename: fileData[0], message: 'Er heeft zich een fout voorgedaan'}))
        });
    };
}

export const deleteFile = (url, fileId, value, addressIndex, fileIndex, addressFileIndex) => {
    let data = new FormData;
    data.append('fileId', fileId);
    data.append('value', value);

    return (dispatch) => {
        dispatch(setLoadingStatus({reducer: 'FileReducer', status: true}))
        fetch(url + '/api/files/action/deleteFile',
        {
            method: "POST",
            body: data
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                data = JSON.parse(data);
                dispatch(setLoadingStatus({reducer: 'FileReducer', status: false}))

                firebase.database().ref('clientData/data/allAddresses/').child(addressIndex).child('files').child(addressFileIndex).child('is_deleted').set(value);
                firebase.database().ref('fileData/files').child(fileIndex).child('is_deleted').set(value);

                dispatch(setMessage({type: data.type, message: data.message}));
                //dispatch(setMessage(data.message))
            })
            .catch((error) => {


            });
    };
}



// WEBPACK FOOTER //
// ./src/actions/file.js